import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import notificationData from '@/static/data/notificationData';

export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationModal',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationData).notifications, (notification) => {
      return (_openBlock(), _createElementBlock("div", {
        key: notification.id
      }, _toDisplayString(notification.message), 1))
    }), 128))
  ]))
}
}

})